import { component } from 'picoapp'
import noodle from 'noodle';

export default component((node, ctx) => {

  //console.log("gallery mounted")

  const sliderWrap = node.querySelector('[data-slider]')
  const sliderNext = node.querySelector('[data-slider-next]')
  const sliderPrev = node.querySelector('[data-slider-prev]')
  const sliderIndexCount = node.querySelector('[data-slider-index-count]')
  const slideCount = sliderWrap.dataset.slideCount;

  const slider = noodle(sliderWrap, {
    setHeight: false,
    a11y: false,
  })

  const onSliderNext = () => {
    if(slider.index == slideCount){
      slider.select(0);
    }else{
      slider.next();
    }
  }

  const onSliderPrev = () => {
    slider.prev();
  }

  const onSliderIndex = (index) => {
    let end = parseFloat(index)+1;
    let start = parseFloat(sliderIndexCount.dataset.sliderIndexCount);

    
    let range = end - start;
    let current = start;
    let increment = end > start? 1 : -1;
    
    sliderIndexCount.dataset.sliderIndexCount = end;
    
    if(start === end ){
      return;
    }
    let timer = setInterval(function() {
        current += increment;
        if(current < 10){
          sliderIndexCount.innerHTML = '0' + current;
        }else{
          sliderIndexCount.innerHTML = current;
        }
        //sliderIndexCount.innerHTML = current;
        if (current == end) {
            clearInterval(timer);
        }
    }, 100);
  }

  sliderNext.addEventListener('click', onSliderNext)
  sliderPrev.addEventListener('click', onSliderPrev)

  slider.on('select', index => {
    //console.log("swipe to " + index);
    onSliderIndex(index);
  })

})
